<template>
    <div class="voltage-rise-calculator__output">
        <div class="voltage-rise-calculator__header">
            <div>
                <h2 class="h3">System Output</h2>
                <span class="voltage-rise-calculator__tick small semi" :class="{'is-completed' : totalWithinLimit}">
                    {{ totalWithinLimit ? 'Within limit' : 'Above limit' }}
                    <figure>
                        <svg v-if="totalWithinLimit" class="icon">
                            <use xlink:href="#tick" />
                        </svg>
                        <svg v-else class="icon">
                            <use xlink:href="#close" />
                        </svg>
                    </figure>
                </span>
            </div>
            <p v-if="totalWithinLimit" class="small semi mb-xl">
                Your system's voltage rise is currently within permissible limits.
            </p>
            <WarningPrompt
                v-else
                text="Your system's voltage rise is above the permissible limit."
                link="Edit the configuration."
                simple
                @clicked="$emit('changeStep', 1)"
            />
            <hr>
        </div>
        <section
            v-for="(distribution,index) in cableDiagram.distribution"
            :key="index"
            class="voltage-rise-calculator__section"
        >
            <VoltageRiseInverter
                :distribution="distribution"
                :supply="cableDiagram.supply"
                :system="cableDiagram.distribution"
                :single-phase-voltage="cableDiagram.singlePhaseVoltage"
                :inverters="inverters"
                @validate="validate"
                @updatedata="updatedata"
            />
        </section>
    </div>
</template>

<script>
/* eslint-disable no-console */
import { axios } from '@/../utils';
import VoltageRiseInverter from './VoltageRiseInverter';
import WarningPrompt from '@/components/WarningPrompt';

export default {
    components: {
        VoltageRiseInverter,
        WarningPrompt
    },

    props: {
        cableDiagram: {
            type: Object,
            required: true
        },
        jobId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            totalWithinLimit: false,
            validation: [],
            voltageRiseData: []
        };
    },

    computed: {
        inverters() {
            return this.cableDiagram.distribution.filter(item => item.isPreExistingSystem == 'false').length;
        },
    },

    watch: {
        validation() {
            this.totalWithinLimit = this.validation.every(value => (value !== false));
        },

        totalWithinLimit() {

            if (this.totalWithinLimit) {
                const response = axios.post(`/account/job/${this.jobId}/VoltageRise/datasheet`, {
                    supply: this.cableDiagram.supply,
                    distribution: this.cableDiagram.distribution,
                    singlePhaseVoltage: this.cableDiagram.singlePhaseVoltage,
                    voltRiseCompleted: true,
                    voltageRiseData: this.voltageRiseData
                });

                console.log(response);
            }
        }
    },

    methods: {
        validate(value) {
            this.validation.push(value);
        },
        updatedata(value) {
            this.voltageRiseData.push(value);
        }
    },
};
</script>
